export enum branchRequestStatus {
  ALL = "All",
  ACTIVE = "Active",
  PENDING = "Pending",
  INACTIVE = "In Active",
  DELETED = "Deleted",
}
